import { useEffect, useState } from 'react'
import { Menu, X } from 'lucide-react'

const links = [
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'How we work', href: '#how-we-work' },
  { label: 'About', href: '#about' },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [open])

  return (
    <header className="absolute inset-x-0 top-0 z-50 text-white">
      <nav aria-label="Main" className="container mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" className="site-focus flex items-center gap-3">
          <span className="w-9 h-9 bg-vault text-mariner font-brandSerif font-semibold text-xl flex items-center justify-center rounded-sm" aria-hidden="true">
            R
          </span>
          <span className="font-brandSerif font-semibold text-lg tracking-tight">Rozitech</span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="site-focus text-sm text-mist hover:text-white transition-colors duration-150 ease-out">
              {link.label}
            </a>
          ))}
          <a href="#brief" className="site-btn-primary site-focus !py-2.5 !px-5 text-sm">
            Start a project brief
          </a>
        </div>

        <button
          type="button"
          className="site-focus md:hidden p-2 text-white"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div id="mobile-menu" className="md:hidden bg-mariner border-t border-ledger px-6 py-6 space-y-5">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="site-focus block text-lg text-mist hover:text-white"
            >
              {link.label}
            </a>
          ))}
          <a href="#brief" onClick={() => setOpen(false)} className="site-btn-primary site-focus w-full">
            Start a project brief
          </a>
        </div>
      )}
    </header>
  )
}
